import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip
  } from "recharts";


function BarChartComponent({data}){
      

    return (
        <ResponsiveContainer width="100%" height={500}>
            <BarChart
                width="100%"
                height="100%"
                data={data}
                layout='vertical'
                maxBarSize={30}
                margin={{
                    top: 0,
                    right: 10,
                    left: 50,
                    bottom: 0
                }}
            >
            <CartesianGrid strokeDasharray="3" />
            <XAxis type="number" allowDecimals={false}/>
            <YAxis dataKey="name" type="category"    />
            <Tooltip />
            <Bar dataKey="count" fill="#6293CA" />
            </BarChart>
        </ResponsiveContainer>
    )

    
}

export default BarChartComponent